import React from 'react'

// router
import { withRouter } from 'react-router-dom'

// utils
import { formatFechaArgentina } from '../../../utils/fechaArgentina'

const ItemDetallePago = ({ item }) => {
    return (
        <tr>
            <th scope="row">{item.id}</th>
            <td>${item.monto.toFixed(2)}</td>
            <td>{item.medioPago.nombre}</td>
            <td>{formatFechaArgentina(item.createdAt)}</td>
        </tr>
    )
}

export default withRouter(ItemDetallePago)
